import BaseModifierBehavior from './BaseModifierBehavior';
import CardStateHelper, { getCardsState } from '../CardStateHelper';
import { CardTask } from '../CardTasks';
import { SCORE_ICE_CARD } from '../../../Constants/Score';
import { ICardsState } from '../ICardState';
import { IGameState } from 'State/Game/IGameState';

export default class IceModifierBehavior extends BaseModifierBehavior {
    public play(state: IGameState): IGameState {
        let cardsState = { ...state.levelState.cardsState };
        const currentCard = CardStateHelper.getCurrentCard(cardsState);

        state = CardStateHelper.setCardDiscarded(state, currentCard);
        cardsState = getCardsState(state);

        // Set action data to trigger ice-break animation.
        cardsState = CardStateHelper.addTurnScore(cardsState, SCORE_ICE_CARD);

        cardsState = CardStateHelper.setStateTaskData(cardsState, {
            task: CardTask.ICE,
            discard: currentCard,
            source: this.cardID,
            cards: [currentCard, this.cardID],
            cardScore: SCORE_ICE_CARD,
        });

        // Clear the undo history when a ice card is played.
        cardsState = CardStateHelper.clearUndoHistory(cardsState);
        cardsState = CardStateHelper.checkFoldNextCard(cardsState);

        return CardStateHelper.updateGameState(state, cardsState);
    }

    public overrideCardPlay(state: ICardsState): boolean {
        return this.modifier.properties.plays === 0;
    }
}
